<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/TMlYBb/tc-custom/9781609943486.jpg?1708779380403" alt="This image is the cover for the book Gangs of America"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Gangs of America
      </h1>
      <p class="bookDescription body article font2">
        <b>“<i>Gangs of America</i> is a brilliant page-turner revealing how powerful, greedy corporations wage institutional terrorism.” </b><b>—John Stauber, coauthor of <i>Toxic Sludge Is Good for You!</i></b><br/>  <br/> The corporation has become the core institution of the modern world. Designed to seek profit and power, it has pursued both with endless tenacity, steadily bending the framework of law and even challenging the sovereign status of the state. Where did the corporation come from? How did it get so much power? What is its ultimate trajectory? <br/>  <br/> After he sold his successful computer book publishing business to a large corporation, Ted Nace felt increasingly driven to find answers to these questions. In <i>Gangs of America</i> he details the rise of corporate power in America through a series of fascinating stories, each organized around a different facet of the central question: “How did corporations get more rights than people?” Beginning with the origin of the corporation in medieval Great Britain, Nace traces both the events that shaped the evolution of corporate power and the colorful personalities who played major roles. <i>Gangs of America</i> is a uniquely accessible synthesis of the latest scholarly research, a compelling historical narrative, and a distinctive personal voice.<br/>  <br/><b>“A surprising and welcome achievement . . . provocative and entertaining.” —<i>The New York Times</i></b><br/>  <br/><b>“A beautifully documented and readable history.” —Ben H. Bagdikian, author of <i>The New Media Monopoly</i></b><br/>  <br/><b>“The essential guide to the history of the American corporation. Nace explodes the myth of inevitability surrounding the corporate takeover of our lives.” —Maria Elena Martinez, Executive director, CorpWatch</b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ted Nace
      </h2>
      
      <p class="authorDescription body article">While working for the u.s. forest service during high school, Ted Nace learned about the plans of several major corporations to develop coal strip mines and other energy projects near his hometown of Dickinson, North Dakota. During graduate school, Nace worked for the Environmental Defense Fund, where he helped develop computerized simulations that demonstrated the investor and ratepayer benefits of re- placing coal-fired power plants with alternative energy programs. The EDF simulations led to the cancellation of a multi-billion-dollar coal- based power complex proposed by two California utilities. After completing his graduate studies, Nace worked for the Dakota Resource Council, a citizens’ group concerned about the impacts of energy development on agriculture and rural communities.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Berrett-Koehler Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?451f5848